import { allSlideTypes } from '@/constant/slideTypes'
import { isFeatureEnabled } from '../featureToggles.module'

const DEFAULT_CUSTOM_SLIDE_SETTING = Object.freeze({
  enableQuestionTitle: true,
  enableQuestionDescription: true,
  enableTimeLimit: true,
  enableStopSubmitssionSetting: true,
  enableHideResultSetting: true,
  enableQuestionImage: true,
  enableVoteCount: true,
  enableLabelOtherSetting: false,
  enableMultipleSubmission: false,
  enableFullScreen: false,
})

const _getters = {
  canUseSlidePlugin: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-39386-aha-slide-plugin')
  },

  slideActiveConfig: (_, __, rootState, rootGetters) => {
    const { type } = rootState.slideActive
    const builtin = allSlideTypes.find((slideType) => slideType.type === type)
    if (builtin) return builtin

    const custom = rootGetters['embedApp/customSlideTypeByType'](type)
    if (!custom) return {}

    return {
      ...custom,
      plugin: true,
      setting: { ...DEFAULT_CUSTOM_SLIDE_SETTING, ...(custom.setting || {}) },
    }
  },

  isSlideActiveFullCanvasPlugin: (_, getters, ___, rootGetters) => {
    if (!isFeatureEnabled(rootGetters, 'AHA-39386-aha-slide-plugin')) return false
    const config = getters.slideActiveConfig
    // `enableFullScreen` is the canonical manifest key (see
    // aha-slide-plugin/packages/toolkit/schema/plugin-manifest.schema.json) —
    // the host's "fullCanvas" layout is the response to that opt-in.
    return Boolean(config.plugin && config.setting?.enableFullScreen)
  },
}

export default _getters
